import img1 from '../images/common/team_1.png';
import img2 from '../images/common/team_2.png';
import img3 from '../images/common/team_3.png';
import img5 from '../images/common/team_5.png';
import img6 from '../images/common/team_6.png';
import img7 from '../images/common/team_7.png';
import img8 from '../images/common/team_8.png';
import img9 from '../images/team/Wizard.png';
import img10 from '../images/team/Dwarf.png';
import img11 from '../images/team/Fairy.png';
import img12 from '../images/team/Warlock.png';
import img13 from '../images/team/Nymph.png';
import img14 from '../images/team/Mermaid.png';
import img15 from '../images/team/Knight.png';


const dataTeam = [
    {
        id: 1,
        img : img9,
        name: 'Lucas Mayor',
        unit: 'Président',
        societe: "Carna'dzons",
    }, 
    {
        id: 2,
        img : img12,
        name: 'Florian Gaspoz',
        unit: 'Caissier',
        societe: "Carna'dzons",
    }, 
    {
        id: 3,
        img : img13,
        name: 'Samuel Morand',
        unit: 'Secrétaire',
        societe: "Carna'dzons",
    }, 
    {
        id: 4,
        img : img11,
        name: 'Océane Rey',
        unit: 'Décoration ',
        societe: "La Perce-Neige",
    }, 
    {
        id: 5,
        img : img14,
        name: 'Léa Rossier',
        unit: 'Décoration',
        societe: "La Perce-Neige",
    },
    {
        id: 7,
        img : img10,
        name: 'Swen Quarroz',
        unit: 'Sécurité, Confettis ',
        societe: "Fifres et Tambours La Maya",
    },
    {
        id: 8,
        img : img9,
        name: 'Maxime Zermatten',
        unit: 'Subsistance',
        societe: "Fifres et Tambours La Maya",
    },
    {
        id: 9,
        img : img12,
        name: 'Antoine Quarroz',
        unit: 'Média sociaux, Animation',
        societe: "La Jeunesse de Saint-Martin",
    },
    {        id: 10,        img : img10,        name: "Denis Beytrison",
        unit: 'Média sociaux, Confettis ',
        societe: "La Jeunesse de Saint-Martin",
    },
    {        id: 11,        img : img15,        name: 'Lionel Mayor',
        unit: 'Guggen, Subsistance',
        societe: "Les Chenegaudes",
    },
    {        id: 12,        img : img9,        name: 'Mathieu Dayer',
        unit: 'Construction',
        societe: "Les Chenegaudes",
    },
    {        id: 13,        img : img10,        name: 'Charlotte',
        unit: 'Décoration',
        societe: "La Coccinelle",
    }
]

export default dataTeam;
